import Brand from '@/api/models/Brand'
import HandleFunctions from '@/models/HandleFunctions'
import { getErrorMessage } from '@/service/error'

function setFavicon (brand: Brand): void {
    const favicon = document.getElementById('favicon')
    if (favicon) {
        const faviconHref = favicon.attributes.getNamedItem('href')
        if (faviconHref) {
            faviconHref.value = `${process.env.VUE_APP_CDN}${brand.key}/favicon/favicon.ico`
        }
    }
}

function setTitle (brand: Brand): void {
    document.title = `Модуль интеграции для ${brand.name} и Яндекс Маркет`
}

async function handleRequest (handleFunctions: HandleFunctions): Promise<void> {
    try {
        await handleFunctions.tryBody()
        if (handleFunctions.onSuccess) {
            handleFunctions.onSuccess()
        }
    } catch (e) {
        console.log(e)
        const message = getErrorMessage(e)

        if (handleFunctions.onFailure) {
            handleFunctions.onFailure(message)
        }
    }

    if (handleFunctions.onFinal) {
        handleFunctions.onFinal()
    }
}

export {
    setTitle,
    setFavicon,
    handleRequest
}
